var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",on:{"click":function($event){return _vm.$emit('close-modal')}}},[_c('div',{staticClass:"container pa-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.foto,"alt":_vm.foto}})])])}
var staticRenderFns = []

export { render, staticRenderFns }